export const CLOSE_ALL = 'CLOSE_ALL';
export const CLOSE_RIGHT = 'CLOSE_RIGHT';
export const CLOSE_CENTER = 'CLOSE_CENTER';
export const SIGN_IN_FORM = 'SIGN_IN_FORM';
export const SIGN_UP_FORM = 'SIGN_UP_FORM';
export const PROFILE_FORM = 'PROFILE_FORM';
export const RECOVER_PASSWORD_FORM = 'RECOVER_PASSWORD_FORM';
export const RESET_PASSWORD_FORM = 'RESET_PASSWORD_FORM';
export const SETTINGS_FORM = 'SETTINGS_FORM';
export const SELECT_PICTURE_FORM = 'SELECT_PICTURE_FORM';
export const NOTIFICATIONS_LIST = 'NOTIFICATIONS_LIST';
export const NOTIFICATION_TOAST = 'NOTIFICATION_TOAST';
export const NO_INTERNET = 'NO_INTERNET';
export const PREVIOUS_ROUTE_NAME = 'PREVIOUS_ROUTE_NAME';



// WEBPACK FOOTER //
// ./src/store/modules/navbar/mutation-types.js